/** A count with the noun agreeing with it: «1 scheda», «34 schede». */
const conteggio = (numero, singolare, plurale) =>
  `${numero} ${numero === 1 ? singolare : plurale}`;

export default conteggio;
